import { createClient } from '@supabase/supabase-js';

// TODO: Replace these with your actual Supabase project credentials
// Find them at: https://app.supabase.com → Project Settings → API
export const SUPABASE_URL = 'https://owcenjxmchuxflofxbpo.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im93Y2VuanhtY2h1eGZsb2Z4YnBvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM3ODYzNjEsImV4cCI6MjA4OTM2MjM2MX0.cj6ub_MN6OY8UTBROloEDfmFkZN6MS3JVNPm5n9z54Y';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

// Database schema reference:
// quotes: id, user_id, client_name, client_email, client_phone, job_description,
//         trade_type, line_items (jsonb), scope_of_work, subtotal, tax_rate,
//         tax_amount, total, markup_percent, status, created_at, updated_at
//
// clients: id, user_id, name, email, phone, address, notes, created_at
//
// user_settings: id, user_id, business_name, business_phone, business_email,
//                business_address, default_markup, default_tax_rate,
//                payment_terms, trade_type, created_at, updated_at
